var SearchFormController;
(function (SearchFormController) {
    myonce("search-form", () => {
        const $search = document.querySelector('#search-form');
        if ($search) {
            const $form = $search.querySelector('form');
            const $input = $form.querySelector('input');
            const $autocomplete = $search.querySelector('.autocomplete');
            const $recent = $search.querySelector('.recent');
            const $suggestions = $search.querySelector('.suggestions');
            const $clearInput = $search.querySelector('[data-clear]');
            const $searchForm = $search.querySelector('.search-form');
            const $closeModal = $search.querySelector('.close');
            const $resetSuggestions = $search.querySelector('.reset');
            init();
            function init() {
                $input.addEventListener('click', () => {
                    $searchForm.classList.add('open');
                    $suggestions.classList.add('is-active');
                    $recent.classList.add('is-active');
                });
                localforage.getItem('recent-searches')
                    .then((searches) => {
                    if (searches && searches.length) {
                        searches.forEach((search) => {
                            const $item = document.createElement('div');
                            $item.innerText = search;
                            $item.classList.add('search-item');
                            $recent.appendChild($item);
                            $item.addEventListener('click', (e) => {
                                if (e.currentTarget === e.target) {
                                    $input.value = search;
                                    trigger($form, 'submit');
                                }
                                else {
                                    removeRecent(search);
                                    $item.remove();
                                }
                            });
                            $resetSuggestions.addEventListener('click', () => {
                                removeRecent(search);
                                $item.remove();
                            });
                        });
                    }
                    else {
                        $recent.remove();
                    }
                });
                $form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    addRecent($input.value)
                        .then(() => {
                        e.target.submit();
                    });
                });
                $suggestions.querySelectorAll('a').forEach(($a) => {
                    $a.addEventListener('click', (e) => {
                        e.preventDefault();
                        $input.value = $a.innerText;
                        trigger($form, 'submit');
                    });
                });
                $input.addEventListener('keyup', debounce(() => {
                    $autocomplete.innerHTML = '';
                    autocomplete($input.value);
                }, 250));
                hiddenBlock();
                clearInput();
                closeModal();
            }
            function hiddenBlock() {
                document.body.addEventListener('click', (event) => {
                    if (event.target !== $input) {
                        $suggestions.classList.remove('is-active');
                        $recent.classList.remove('is-active');
                        $autocomplete.classList.remove('is-active');
                    }
                });
            }
            function closeModal() {
                $closeModal.addEventListener('click', () => {
                    $searchForm.classList.remove('open');
                });
            }
            function clearInput() {
                $clearInput.addEventListener('click', () => {
                    $input.value = '';
                });
            }
            function addRecent(term) {
                return localforage.getItem('recent-searches')
                    .then((searches) => {
                    searches = searches || [];
                    if (!searches.includes(term)) {
                        searches.push(term);
                        if (searches.length > 5) {
                            searches.shift();
                        }
                        localforage.setItem('recent-searches', searches);
                    }
                });
            }
            function removeRecent(term) {
                return localforage.getItem('recent-searches')
                    .then((searches) => {
                    if (searches && searches.length) {
                        const i = searches.indexOf(term);
                        if (i >= 0) {
                            searches.splice(i, 1);
                            localforage.setItem('recent-searches', searches);
                            if (!searches.length) {
                                $recent.remove();
                            }
                        }
                    }
                });
            }
            function autocomplete(value) {
                if (value && value.length >= 3) {
                    Fetch('/search_api_autocomplete/autocomplete', {
                        method: 'GET',
                        data: {
                            display: 'default',
                            filter: 'search_api_fulltext',
                            q: value,
                            token: true,
                        }
                    }).then((response) => {
                        if (response && response.length) {
                            response.forEach((result) => {
                                const $item = document.createElement('div');
                                const $icon = document.createElement('i');
                                const $span = document.createElement('span');
                                let value = result.value || '';
                                value = value[0].toUpperCase() + value.slice(1);
                                value = value.replace(/<([^>]+?)([^>]*?)>/ig, "");
                                $span.innerText = value;
                                $item.classList.add('suggestion');
                                $icon.classList.add('icn');
                                $icon.classList.add('icn-search');
                                $item.appendChild($icon);
                                $item.appendChild($span);
                                $autocomplete.appendChild($item);
                                $item.addEventListener('click', () => {
                                    $input.value = value;
                                    trigger($form, 'submit');
                                });
                            });
                            $autocomplete.classList.add('is-active');
                        }
                        else {
                            disable();
                        }
                    }).catch(() => {
                        disable();
                    });
                }
                else {
                    disable();
                }
                function disable() {
                    $autocomplete.innerHTML = '';
                    $autocomplete.classList.remove('is-active');
                }
            }
        }
    });
})(SearchFormController || (SearchFormController = {}));
